import {
  DELETE_BUYER_CONTACT_REQUESTED,
  DELETE_BUYER_CONTACT_SUCCESS,
  DELETE_BUYER_CONTACT_FAILED,
  ADD_NEW_BUYER_CONTACT_REQUESTED,
  ADD_NEW_BUYER_CONTACT_FAILED,
  ADD_NEW_BUYER_CONTACT_SUCCESS,
  UPDATE_BUYER_CONTACT_REQUESTED,
  UPDATE_BUYER_CONTACT_FAILED,
  UPDATE_BUYER_CONTACT_SUCCESS,
  CLEAR_BUYER_CONTACT,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const buyerContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_BUYER_CONTACT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case DELETE_BUYER_CONTACT_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case DELETE_BUYER_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case ADD_NEW_BUYER_CONTACT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_BUYER_CONTACT_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case ADD_NEW_BUYER_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case UPDATE_BUYER_CONTACT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_BUYER_CONTACT_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case UPDATE_BUYER_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case CLEAR_BUYER_CONTACT:
      return initialState;
    default:
      return state;
  }
};

export default buyerContactReducer;
